export const SET_SUPERUSER_SCHOOL_TABLE_SCROLL =
  "SET_SUPERUSER_SCHOOL_TABLE_SCROLL";

export function setSuperuserSchoolTableScroll(scrollPos) {
  return function (dispatch) {
    dispatch({
      type: SET_SUPERUSER_SCHOOL_TABLE_SCROLL,
      payload: scrollPos,
    });
  };
}
